import { defineMessages } from 'react-intl';

export const allowedTimesMessages = defineMessages({
    dayOfWeek: {
        id: 'day-of-week',
        defaultMessage: 'Day of week',
    },
    allowedTime: {
        id: 'allowed-time',
        defaultMessage: 'Allowed time',
    },
    time: {
        id: 'time',
        defaultMessage: 'Time',
    },
    times: {
        id: 'times',
        defaultMessage: 'Times',
    },
    from: {
        id: 'from',
        defaultMessage: 'From',
    },
    to: {
        id: 'to',
        defaultMessage: 'To',
    },
    addAllowedTimeModalSubtitle: {
        id: 'add-allowed-time-modal-subtitle',
        defaultMessage: 'Add a new allowed time',
    },
    createAllowedTimeSuccess: {
        id: 'create-allowed-time-success',
        defaultMessage: 'Allowed time created',
    },
    createAllowedTimeSuccessDescription: {
        id: 'create-allowed-time-success-description',
        defaultMessage:
            'Allowed time has been successfully created. The changes apply to memberships, and active stays may be re-evaluated.',
    },
    deleteAllowedTimeSuccessDescription: {
        id: 'delete-allowed-time-success-description',
        defaultMessage:
            'Allowed time for {entry} has been successfully deleted. The changes apply to memberships, and active stays may be re-evaluated.',
    },
    deleteAllowedTime: {
        id: 'delete-allowed-time',
        defaultMessage: 'Delete allowed time',
    },
    deleteAllowedTimeSubtitle: {
        id: 'delete-allowed-time-subtitle',
        defaultMessage: 'Permanently delete allowed time for {entry}',
    },
    confirmDeleteAllowedTime: {
        id: 'confirm-delete-allowed-time',
        defaultMessage: 'Are you sure you want to delete allowed time for {entry}? This action cannot be undone.',
    },
    deleteAllowedTimeSuccess: {
        id: 'delete-allowed-time-success',
        defaultMessage: 'Allowed time deleted',
    },
    updateAllowedTimeSuccess: {
        id: 'update-allowed-time-success',
        defaultMessage: 'Allowed time updated',
    },
    updateAllowedTimeSuccessDescription: {
        id: 'update-allowed-time-success-description',
        defaultMessage: 'Allowed time for {entry} has been successfully updated.',
    },
    editAllowedTimeSubtitle: {
        id: 'edit-allowed-time-subtitle',
        defaultMessage: 'Edit allowed time for {entry}',
    },
    inheritedAllowedTime: {
        id: 'inherited-allowed-time',
        defaultMessage: 'Allowed time - inherited from {entry}',
    },
    allowedTimesCanNotBeDefined: {
        id: 'allowed-times-can-not-be-defined',
        defaultMessage: 'Allowed times can not be defined in this template',
    },
    allowedTimesCanNotBeDefinedSubtitle: {
        id: 'allowed-times-can-not-be-defined-subtitle',
        defaultMessage:
            'You have selected "Custom time restriction" to be Yes, and therefore the allowed times are to be individually defined in each membership.',
    },
});
